<div *ngIf="!isSeller" id="main">
    <div [ngClass]="{'seller-chat':isSeller}" class="chat container">
        <cdk-virtual-scroll-viewport [ngClass]="{'seller-chat-box-list':isSeller}" class="chat-box-list row"
                                     itemSize="20">
            <div *ngFor="let msg of messages;">
                <span class="chat-item">
                    <span [ngClass]="{'seller-chat-name':isSeller}" class="chat-name">{{msg.sender}}:</span>
                    <span class="chat-message"> {{msg.text}}</span>
                </span>
            </div>
        </cdk-virtual-scroll-viewport>
        <span *ngFor="let round of likeRound;">
              <app-like-animation [id]="animationId" [index]="0" (indexOutput)="removeIndex($event)"></app-like-animation>
        </span>
        <div [ngClass]="{'seller-chat-form':isSeller}" class="chat-form row">
           <span>
               <input (keyup.enter)="sendMessage(messagesChat)" [(ngModel)]="messagesChat"
                      [ngClass]="{'seller-message':isSeller}" id="message"
                      placeholder="พิมพ์ข้อความของคุณ" type="text">
           </span>
            <span *ngIf="!isSeller">
             <button (click)="sendMessage(messagesChat)"
                     class="chat-send-button p-button-rounded p-button-secondary p-button-outlined" icon="pi pi-send"
                     pButton
                     pRipple></button>
           </span>
            <span *ngIf="!isSeller" class="p-overlay-badge">
             <div class="p-badge">
                  <span class="like-count">{{likeCount || 0}}</span>
             </div>
             <div (click)="like(); animationToggle()" class="chat-like-button">
               <img alt="" class="heart" src="assets/img/Logo_point_pay.png"/>
             </div>
           </span>
        </div>
    </div>
</div>
<div *ngIf="isSeller">
    <div>
        <cdk-virtual-scroll-viewport [ngClass]="{'seller-chat-box-list':isSeller}" class="row"
                                     itemSize="20">
            <div *ngFor="let msg of messages;">
                <span>
                    <span class="chat-name">{{msg.sender}}:</span>
                    <span class="chat-message"> {{msg.text}}</span>
                </span>
            </div>
        </cdk-virtual-scroll-viewport>
    </div>
    <div style="margin-top: 10px">
        <input (keyup.enter)="sendMessage(messagesChat)" [(ngModel)]="messagesChat"
               placeholder="พิมพ์ข้อความของคุณ" style="width: 100%;text-align: center" type="text"/>
    </div>
</div>
